import { render, staticRenderFns } from "./emailservice.vue?vue&type=template&id=4fdf3c6a&"
import script from "./emailservice.vue?vue&type=script&lang=js&"
export * from "./emailservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports